import React, { useEffect, useState } from 'react';
import {api} from "../../app/http-common";

const Ticker = () => {
    const [news, setNews] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        // Mock fetching news data
        const fetchNews = async () => {
            try {
                // This is where you would fetch data from an API
                // Here we use the provided example news object directly
                const newsObject = await api.ticker();

                setNews(newsObject);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchNews();
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div style={styles.container}>
            <h1>Latest Tech News</h1>
            {Object.keys(news).map((source, index) => (
                <div key={index}>
                    <h2>{source}</h2>
                    <ul>
                        {news[source].map((headline, idx) => (
                            <li key={idx} style={styles.headline}>{headline}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
};

const styles = {
    container: {
        padding: '20px',
        backgroundColor: '#f4f4f4',
        borderRadius: '5px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '1000px',
        margin: '0 auto',
    },
    headline: {
        backgroundColor: '#fff',
        padding: '10px',
        borderRadius: '5px',
        margin: '10px 0',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
    },
};

export default Ticker;
